import { Routes } from "@shuttlerock/router";
import { useCallback } from "react";
import { useNavigate } from "react-router";

export const useSignOut = () => {
  const navigate = useNavigate();

  return useCallback(() => {
    return navigate(Routes.Auth.SignOut);
  }, [navigate]);
};
